import React, { useState, useEffect } from "react";
import { Grid, FormLabel, Select, MenuItem, FormControl } from "@material-ui/core";
import { HARDWARE_SOURCE_TO_SENSOR_TYPE_MAP } from "./constant";
import { useStyles } from "src/styles/FormSelectStyles";

interface Option {
    name: string,
    value: string
}

type HardwareSourceAndSensorGroupSelectsProps = {
    hardwareSource: string,
    sensorType: string,
    hardwareSourceOptions: Array<Option>,
    showHardwareSourceError?: boolean,
    onSelectHardwareSource: (value:string) => void, 
    onSelectSensor: (value:string) => void  
}

/**
 * The Component combine hardware source dropdown and sensor dropdown. Sensor dropdown is disable if user doesn't select a hardware source,
 * and its default selection is "ALL".
 */
const HardwareSourceAndSensorGroupSelects: React.FunctionComponent<HardwareSourceAndSensorGroupSelectsProps> = 
    ({ hardwareSource, sensorType, hardwareSourceOptions, showHardwareSourceError, onSelectHardwareSource, onSelectSensor }) => {
    
    const styles = useStyles();
    const [selectedHardwareSource, setSelectedHardwareSource] = useState('');
    const [selectedSensor, setSelectedSensor] = useState('');

    useEffect(() => {
        setSelectedHardwareSource(hardwareSource);
        setSelectedSensor(sensorType)
    },[hardwareSource, sensorType])

    let relatedSensorType: { name: string; value: string; }[] =[];
    if (selectedHardwareSource !== "") {
        const hardwareSourceTyped = selectedHardwareSource as keyof typeof HARDWARE_SOURCE_TO_SENSOR_TYPE_MAP;
        relatedSensorType = HARDWARE_SOURCE_TO_SENSOR_TYPE_MAP[hardwareSourceTyped];
    }    

    const handleHardwareSourceChange = (event: React.ChangeEvent<any>) => {
        setSelectedHardwareSource(event.target.value);
        onSelectHardwareSource(event.target.value);
        setSelectedSensor("ALL");  
    }

    const handleSensorChange = (event: React.ChangeEvent<any>) => {
        setSelectedSensor(event.target.value);
        onSelectSensor(event.target.value);
    }

    const listOfHardwareSource = hardwareSourceOptions.map((hardwareSourceOption) => (
        <MenuItem key={hardwareSourceOption.value} value={hardwareSourceOption.value}>
            {hardwareSourceOption.name}
        </MenuItem>       
    ));

    const listOfSensor = relatedSensorType.map((sensorOption) => (
        <MenuItem key={sensorOption.value} value={sensorOption.value}>
            {sensorOption.name}
        </MenuItem>
    ));

    return (
        <>
            <Grid item>
                <FormControl fullWidth>
                    <Grid 
                        container 
                        alignItems="center" 
                        spacing={1}>
                        <Grid item>
                            <FormLabel 
                                className={`${styles.selectLabel} ${showHardwareSourceError ? `${styles.errorLabel}` : ""}`}
                                error={showHardwareSourceError}>
                                Hardware Source:
                            </FormLabel>
                        </Grid>
                        <Grid item>
                            <Select 
                                className={styles.selectBox}
                                disableUnderline
                                displayEmpty
                                value={selectedHardwareSource}
                                onChange={handleHardwareSourceChange}>
                                <MenuItem value="" disabled>Please select region first</MenuItem>
                                {listOfHardwareSource}  
                            </Select>   
                        </Grid>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item>
                <FormControl fullWidth>
                    <Grid 
                        container 
                        alignItems="center" 
                        spacing={1}>
                        <Grid item>
                            <FormLabel className={styles.selectLabel}>Sensor:</FormLabel>
                        </Grid>
                        <Grid item>
                            <Select 
                                className={styles.selectBox}
                                disableUnderline
                                displayEmpty
                                value={selectedSensor}
                                onChange={handleSensorChange}>
                                <MenuItem value="ALL" disabled>Please select hardware source first</MenuItem>
                                {listOfSensor}
                            </Select>   
                        </Grid>
                    </Grid>
                </FormControl>
            </Grid>
        </>
    ); 
}

export default HardwareSourceAndSensorGroupSelects;
